import qs from 'qs'
import utils from 'axios/lib/utils'

export const isNode = typeof window === 'undefined'

export const isArray = (data) => Object.prototype.toString.call(data) === '[object Array]'

export const isAndroid = isNode ? true : /android/i.test(window.navigator.userAgent)

export const isFunction = (key) => key && typeof key === 'function'

export const isFormData = (val) => typeof FormData !== 'undefined' && val instanceof FormData

export const isIframe = isNode ? false : window.parent !== window.self

export const getCookie = (key, from) => {
  let result = ''
  if (isNode && !from) {
    return result
  }
  const cookies = from || document.cookie
  if (!cookies) {
    return result
  }
  const arr = cookies.split(';')
  const reg = new RegExp(`^${key}=`)
  for (let i = 0; i < arr.length; i++) {
    const tmp = arr[i].trim()
    if (reg.test(tmp)) {
      result = tmp.split('=')[1]
      break
    }
  }
  return result
}

export const blob2Base64 = (blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader()

    reader.onload = (event) => {
      resolve(event.target.result)
    }

    reader.readAsDataURL(blob)
  })
}

export const isBlob = (val) => toString.call(val) === '[object Blob]' || toString.call(val) === '[object File]'
// eslint-disable-next-line
export const isBase64 = (val) => val && typeof val ==='string' && val.indexOf('base64') !== -1 && /^data:/.test(val)

export const debugFn = (option, message) => {
  if (!option.debug) {
    return
  }

  if (isFunction(option.debug)) {
    option.debug(message)
  } else {
    // eslint-disable-next-line
    console.log(message)
  }
}

export const paramSerializer = (dataObj, config, runtime) => {
  if (config.dataSerializer) {
    return config.dataSerializer(dataObj)
  }

  const parts = []
  /**
   * iOS 的新版本 bridge 不会 encode 参数
   * 并且使用 encodeURIComponent 无法 encode 如：( 之类的字符
   * 所以这里需要使用 qs
   * @type {boolean}
   */
  const useQS = !isAndroid && (runtime.version === 6 || runtime.version === 7)
  if (useQS) {
    return qs.stringify(dataObj)
  }

  utils.forEach(dataObj, function serialize(val, key) {
    if (val === null || typeof val === 'undefined') {
      return
    }

    if (utils.isArray(val)) {
      key = key + '[]'
    } else {
      val = [val]
    }

    function encode(val) {
      return encodeURIComponent(val)
        .replace(/%3A/gi, ':')
        .replace(/%24/g, '$')
        .replace(/%2C/gi, ',')
        .replace(/%20/g, '+')
        .replace(/%5B/gi, '[')
        .replace(/%5D/gi, ']')
    }

    utils.forEach(val, function parseValue(v) {
      if (utils.isDate(v)) {
        v = v.toISOString()
      } else if (utils.isObject(v)) {
        v = JSON.stringify(v)
      }

      if (runtime.version === 1 && /^(pwd|password|seccode)/.test(key)) {
        parts.push(encode(key) + '=' + v)
      } else {
        parts.push(encode(key) + '=' + encode(v))
      }
    })
  })

  return parts.sort((a, b) => (a > b ? 1 : -1)).join('&')
}
